import Vue from "vue";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./router";

// Google Analytics
if (process.env.NODE_ENV == "production") {
    Vue.use(VueGtag, {
        config: {
            id: 'UA-147635647-2'
        }
    }, router);
}

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
